module.exports = __webpack_public_path__ + "app/components/login/login.view.html";